export default {
  namespaced: true,
  state: () => ({}),
  getters: {
    isMobile: () => screen.width <= 600,
  },
  mutations: {},
  //调用mutations方法，可以使用异步方法
  actions: {},
};
